import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from "react-bootstrap/Modal";
import choVayConst, { LaiSuatText2 } from "constants/choVayConst";
import { formatNumber } from "utils/currencyFormat";
import { convertToNumber } from "utils/numberExtension";
import { pushNotification } from "utils/notifications";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { getDate, currentDate, formatDayMonth } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import TatToanChoDuyetApi from "../../../../service/tatToanChoDuyetApi";
import QuanLyChoVayApi from "../../../../service/quanLyChoVayApi";
import NhanVayApi from "../../../../service/nhanVayApi";
// import {
//     getListTatToanChoDuyet,
//     updateDataSearch,
// } from "../../../../actions/DanhSachTatToanChoDuyet";
const TatToanHopDong = ({ show, onHide, item, SearchDanhSach }) => {
  const dispatch = useDispatch();
  // const listTatToanChoDuyetFull = useSelector(
  //     (state) => state.listTatToanChoDuyetFull
  // );
  const dataSearch = useSelector((state) => state.dataSearchTatToanChoDuyet);

  const initTatToan = {
    TatToanChoDuyetID: 0,
    NguoiThanhToan: "",
    NgayThanhToan: "",
    TienTatToan: 0,
    PhiKhac: 0,
    PhiKho: 0,
    GhiChu: "",
  };
  const [dataTatToan, setDataTatToan] = useState(initTatToan);
  useEffect(() => {
    setDataTatToan({
      ...dataTatToan,
      TatToanChoDuyetID: convertToNumber(item.TatToanChoDuyetID),
      NguoiThanhToan: item.Name,
      NgayThanhToan: convertDate(getDate(item.Time)),
      TienTatToan: convertToNumber(item.Value),
      PhiKhac: convertToNumber(item.OtherFee),
      PhiKho: convertToNumber(item.PhiKho),
      OtherFeeHangKy: convertToNumber(item.OtherFeeHangKy),
      PhiChamDongLai: convertToNumber(item.PhiChamDongLai),
      PhiTatToanSom: convertToNumber(item.PhiTatToanSom),
      PhiTatToanQuaHan: convertToNumber(item.PhiTatToanQuaHan),
      GhiChu: "",
    });
  }, []);

  const onChangeData = (field) => (event) => {
    setDataTatToan({
      ...dataTatToan,
      [field]: event.target.value,
    });
  };

  const onChangeNumber = (field) => (evt) => {
    setDataTatToan({
      ...dataTatToan,
      [field]: convertToNumber(evt.target.value),
    });
  };

  const onChangeDate = (field) => (evt) => {
    setDataTatToan({
      ...dataTatToan,
      [field]: convertDate(getDate(formatDayMonth(evt))),
    });
    layThongTinTatToan(formatDayMonth(evt));
  };

  const layThongTinTatToan = (date) => {
    if (item.ChoVayId > 0) {
      QuanLyChoVayApi.getTatToan1(item.ChoVayId, date).then((response) => {
        if (response.data.Error === 1) {
          pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
          setDataTatToan({
            ...dataTatToan,
            NgayThanhToan: convertDate(getDate(item.Time)),
            TienTatToan: convertToNumber(item.Value),
          });
        } else {
          if (response.data.ThongTinTatToan) {
            setDataTatToan({
              ...dataTatToan,
              TienTatToan: convertToNumber(
                response.data.ThongTinTatToan.TienTatToan
              ),
              NgayThanhToan: convertDate(getDate(date)),
            });
          }
        }
      });
    } else if (item.NhanVayId > 0) {
      NhanVayApi.getChiTietHopDong(item.NhanVayId, date).then((response) => {
        console.log(response, "responseresponseresponseresponseresponse");
        if (response.data.Error === 1) {
          pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
          setDataTatToan({
            ...dataTatToan,
            NgayThanhToan: convertDate(getDate(item.Time)),
            TienTatToan: convertToNumber(item.Value),
          });
        } else {
          if (response.data) {
            setDataTatToan({
              ...dataTatToan,
              TienTatToan: convertToNumber(response.data.SoTienConPhaiTra),
              NgayThanhToan: convertDate(getDate(date)),
            });
          }
        }
      });
    }

    return;
    // let { getTatToanChoVay } = this.props;
    // getTatToanChoVay({
    //   choVayId: objTatToan.choVayId,
    //   ngaythanhtoan: objTatToan.NgayThucHien,
    // });
  };

  const tatToan = () => () => {
    if (!dataTatToan.NguoiThanhToan) {
      pushNotification(
        "Nhập tên người thanh toans.",
        "warning",
        "TOP_CENTER",
        1000
      );
      this.TenKhachhang.current.focus();
      return;
    }
    if (!dataTatToan.TienTatToan) {
      pushNotification("Nhập tiền tất toán", "warning", "TOP_CENTER", 1000);
      this.SoTien.current.focus();
      return;
    }

    dataTatToan.NgayThanhToan = formatDayMonth(dataTatToan.NgayThanhToan);

    TatToanChoDuyetApi.capNhatTatToan(dataTatToan).then((response) => {
      if (response.data.Error === 1) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 3000);
        setDataTatToan({
          ...dataTatToan,
          NgayThanhToan: convertDate(getDate(dataTatToan.NgayThanhToan)),
        });
      } else {
        pushNotification(response.data.Message, "success", "TOP_CENTER", 3000);
        setDataTatToan({
          ...dataTatToan,
          NgayThanhToan: convertDate(getDate(dataTatToan.NgayThanhToan)),
        });
        SearchDanhSach();
        onHide();
      }
    });
  };

  return (
    <Modal
      show={show}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img
              className="icon-bred-home"
              src="/app-assets/images/logo-quan-ly-tai-san.png"
              alt=""
            />
          </span>{" "}
          Sửa tất toán hợp đồng
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="form-body">
              <div
                aria-labelledby="heading61"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-5">
                        <ul className="list-detailHD">
                          <li>
                            Hợp đồng: <b>{item.Code}</b>
                          </li>
                          <li>
                            Ngày tất toán: <b>{getDate(item.Time)}</b>
                          </li>
                          <li>
                            Người tạo: <b>{item.UserName}</b>
                          </li>
                          <li>
                            Số tiền tất toán: <b>{formatNumber(item.Value)}</b>
                          </li>
                          <li>
                            Phí khác: <b>{formatNumber(item.OtherFee)}</b>
                          </li>
                          <li>
                            Phí kho: <b>{formatNumber(item.PhiKho)}</b>
                          </li>
                          <li>
                            Phí hàng kỳ:{" "}
                            <b>{formatNumber(item.OtherFeeHangKy)}</b>
                          </li>
                          <li>
                            Phí châm đóng lãi:{" "}
                            <b>{formatNumber(item.PhiChamDongLai)}</b>
                          </li>
                          <li>
                            Phí tất toán sớm:{" "}
                            <b>{formatNumber(item.PhiTatToanSom)}</b>
                          </li>
                          <li>
                            Phí tát toán chậm:{" "}
                            <b>{formatNumber(item.PhiTatToanQuaHan)}</b>
                          </li>
                          <li>
                            Tổng tiền tất toán:{" "}
                            <b className="color-do-bold">
                              {formatNumber(
                                item.Value +
                                  item.OtherFee +
                                  item.PhiKho +
                                  item.OtherFeeHangKy +
                                  item.PhiChamDongLai +
                                  item.PhiTatToanSom +
                                  item.PhiTatToanQuaHan
                              )}
                            </b>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-7">
                        <div
                          className="row"
                          style={{ background: "#e0eff0", padding: "10px" }}
                        >
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Người thanh toán</label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                value={dataTatToan.NguoiThanhToan}
                                onChange={onChangeData("NguoiThanhToan")}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Ngày thanh toán</label>
                              <DateTimePicker
                                value={dataTatToan.NgayThanhToan}
                                onChange={onChangeDate("NgayThanhToan")}
                              ></DateTimePicker>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Tiền tất toán</label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                value={formatNumber(dataTatToan.TienTatToan)}
                                onChange={onChangeNumber("TienTatToan")}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Phí khác</label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                value={formatNumber(dataTatToan.PhiKhac)}
                                onChange={onChangeNumber("PhiKhac")}
                              />
                            </div>
                          </div>
                          {/*&& isShowPhiKho == 1  */}
                          {/* {data.Type === 3 && ( */}
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Phí kho</label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                value={formatNumber(dataTatToan.PhiKho)}
                                onChange={onChangeNumber("PhiKho")}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Phí hàng kỳ</label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                value={formatNumber(dataTatToan.OtherFeeHangKy)}
                                onChange={onChangeNumber("OtherFeeHangKy")}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Phí phạt đóng lãi chậm</label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                value={formatNumber(dataTatToan.PhiChamDongLai)}
                                onChange={onChangeNumber("PhiChamDongLai")}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Phí tất toán sớm</label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                value={formatNumber(dataTatToan.PhiTatToanSom)}
                                onChange={onChangeNumber("PhiTatToanSom")}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Phí tất toán chậm</label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                value={formatNumber(
                                  dataTatToan.PhiTatToanQuaHan
                                )}
                                onChange={onChangeNumber("PhiTatToanQuaHan")}
                              />
                            </div>
                          </div>
                          {/* )} */}
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Tổng tiền thu</label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                value={formatNumber(
                                  dataTatToan.TienTatToan +
                                    dataTatToan.PhiKhac +
                                    dataTatToan.PhiKho +
                                    dataTatToan.OtherFeeHangKy +
                                    dataTatToan.PhiChamDongLai +
                                    dataTatToan.PhiTatToanSom +
                                    dataTatToan.PhiTatToanQuaHan
                                )}
                                disabled
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Ghi chú</label>
                              <textarea
                                rows="3"
                                className="form-control input-sm"
                                placeholder="Ghi chú"
                                value={dataTatToan.GhiChu}
                                onChange={onChangeData("GhiChu")}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-new-main btn-checknew"
          onClick={tatToan()}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-check-underline-circle"></i>
          </span>{" "}
          {item.BuocDuyet === 0 ? <>Gửi duyệt</> : <> Xác nhận</>}
        </button>
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
export default TatToanHopDong;
